export default __webpack_public_path__ + "static/media/ttmikbooks_05.c934e775.jpg";